webpackJsonp([62],{

/***/ "+JQD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAABGdBTUEAALGPC/xhBQAABG5JREFUWAntWFtTFEcUPgO7yy735RZA0IKIeOOiElihsmblksK/oG/xH1j5E/E5T0ke8xekCqIkLKYwKSsCsRSSaMWAqBBQAgyssJM+jac9M72zO2O0KpXKVO2ec77+zjene3t6uhcgw2Ugdm10wop90AFTP04DNNWF84gYLS+VbmQhYCgQkaH+Ptmg0mUkvi4MxSVG8T7r2mhyE8AqPNhQB48WliDPMKy8+toaOHHssGRI8Y62VpVmTE5OlqxvpdcJUapYLIFkRePS8FC8XpJGxiZMy4Jw95k2qKwol5yRsaS0kWBjJEBZaH+4PctD5StSb88pKCstVg3okJoNdAv2a/pm4gsrDZedpFBeqHZgIPZU9p8TBhO9iptKp55gYPsFhgc/hEAgH9Dyy0biDdxXvUPQrTeK9F51JZzuPK4EeIK6HScgk9ellHimkjNA9k7F/9RRM0VMhM/ERPjUryDNYS4kZxQX4v1DfO35C/H8zHAK4GxLJJq21SDZWkVw/lyPE4JoeZmGEeAqdOO7W7C8sko8accnbtliHrgKIWn1+TqY5jbs7e3Byp9rkJ+fz3NtvvppCQ2FgtB/LkahslWVUYj3dcl4VwiP3fhetaGjhMTD/YuI21Kpl65T05b5KsCBzoT/hzA1IZPJZHTDtGbEWDV46Z9hwNfDg/FLxFU//1+mtepVBJPF43RxZDT5pSZEALcH6mpgIHEWznZ3clj5FlifUKAqIoDsmc4T0H6yFYKBAJSXldjWFeJw6ypUU13BedLvi53SMAJchYjAbXFRIQ9tvi+h+/MPbck8cBW6/u0U58Hq2gv4/Y/HNowH6lnjIPqpl/6eOVehSLhAvtsromVCdBcWFp/Arw8eOe+n4oxCg+d7IcDWnojwW94/JD8zP8/B4tIzJUCONkb9H8VsIkQki3MLq3VemlAoGHRytLi7q13DtK5lfAlqaa8Aw1ikJlWRWAbcJwmxnbbAcp/qTu7/8dsaAbVik6Dc1prWHbGSNhP2Tizuqgqg/UI8vsz11SQicN1M33znxeDNLKiFHeMnui9Z7fEQQ9YiXklZL3wW208egeoqfU3HRFwAp2fvw/ZOKquO6PiB8fGHYb530EYouwIAnmNwlXErBvNxHUzEe+BQY30uOa3dd0FHW5s0ETfg6BHvXNLwXdDGxhbl5rQbm965JOa7IDz1PVu2b5dJjFvc1N+c0uYsp2T0tUmdkeUAb9+5KxHcNjWKg3JJsdhTiJ3bphi9hcdP5cHZkeI5fKOCSB3fs5netdT+JtZXQfh+PtbaDDXiIGqIEcl1La+swb2532Bzy8xFVe2eCsI95OmO456KUMrCqa6Kik+XWG4smL0772k0cxZ0uPmg3ArxG/n1cTRxB1RaUgz35h9kTdcKsiwjjes6XUVFEe0QSm1+bWFhWEsxG3Zf30y0agWJf5U+5wf+6dk5TeRtAQYYXw23tOxwvYwzc/+sBlfFSH0syvd0XuOiWX3xlhc3vR40Qlfwb6Ss3H9D49+bHjxq3Q09uwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "+P7g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _modules_user = __webpack_require__("cDbO");

var _modules_user2 = _interopRequireDefault(_modules_user);

var _modules_payment = __webpack_require__("LOKH");

var _modules_payment2 = _interopRequireDefault(_modules_payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    modules: {
        user: _modules_user2.default,
        payment: _modules_payment2.default
    }
});

/***/ }),

/***/ "0xBU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_qr_gzh.d13e4c6.png";

/***/ }),

/***/ "1tYL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gaba.d0289dc.png";

/***/ }),

/***/ "28he":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    install: function install(Vue) {
        Vue.handleError = function (err, msg) {
            if (typeof arguments[0] === 'string') {
                err = { msg: arguments[0] };
            }
            Vue.prototype.$message.error(err.msg || err.message || msg || '请求失败');
        };
        Object.defineProperty(Vue.prototype, '$handleError', { value: Vue.handleError });
    }
};

/***/ }),

/***/ "4Cf5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [{
        path: '/',
        name: 'home',
        meta: { name: '中小学在线一对一辅导教育平台', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "HTM0"));
        }
    },
    // 下载页
    {
        path: '/download',
        name: 'download',
        meta: { name: '下载页', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "HiPB"));
        }
    },
    // 隐私政策
    {
        path: '/privacy-agreement',
        name: 'privacy-agreement',
        meta: { name: '隐私政策', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "B1lS"));
        }
    },
    // 用户协议
    {
        path: '/user-agreement',
        name: 'user-agreement',
        meta: { name: '用户协议', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "3Cy8"));
        }
    },
    // 儿童隐私政策
    {
        path: '/child-privary-policy',
        name: 'child-privary-policy',
        meta: { name: '儿童隐私政策', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "uR8B"));
        }
    },
    // 备案承诺公示
    {
        path: '/publicity-commitment',
        name: 'publicityCommitment',
        meta: { name: '备案承诺公示', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "TIKv"));
        }
    },
    // 教师信息页
    {
        path: '/teacherInfo',
        name: 'teacherInfo',
        meta: { name: '教师信息页', isFullScreen: true },
        component: function component() {
            return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "fbSy"));
        }
    },
    // 登录页
    {
        path: '/account',
        component: function component() {
            return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "26te"));
        },
        children: [{
            path: 'login',
            name: 'login@account',
            meta: { name: '登录', isFullScreen: true },
            component: function component() {
                return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "NMV+"));
            }
        }, {
            path: 'register',
            name: 'register@account',
            meta: { name: '注册', isFullScreen: true, illustrations: true },
            component: function component() {
                return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "2FLM"));
            }
        }, {
            path: 'find',
            name: 'find@account',
            meta: { name: '找回密码', isFullScreen: true, illustrations: true },
            component: function component() {
                return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "93xX"));
            }
        }]
    },
    // 我的辅导
    {
        path: '/course/schedule',
        name: 'schedule@course',
        meta: { name: '我的辅导' },
        component: function component() {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "kE25"));
        }
    }, {
        path: '/course/plan',
        name: 'plan@course',
        meta: { name: '课程规划' },
        component: function component() {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "pu5i"));
        }
    },
    // 课程规划下 正式、试听报告
    {
        path: '/course/report',
        name: 'report@course',
        meta: { name: '课后报告' },
        component: function component() {
            return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "tlgQ"));
        }
    },
    // 视频回放列表
    {
        path: '/course/video',
        name: 'video@course',
        meta: { name: '视频回放' },
        component: function component() {
            return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "FNvz"));
        }
    },
    // 视频回放详情
    {
        path: '/course/video/detail',
        name: 'videoDetail@course',
        meta: { name: '视频回放详情' },
        component: function component() {
            return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "7TXZ"));
        }
    },
    // 消费记录
    {
        path: '/record/tuition',
        name: 'tuition@record',
        meta: { name: '我的余额' },
        component: function component() {
            return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "2SJG"));
        }
    },
    // 充值学费
    {
        path: '/record/charge',
        name: 'charge@record',
        meta: { name: '充值学费' },
        component: function component() {
            return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "GNsS"));
        }
    },
    // 课时包购买
    {
        path: '/package/charge',
        name: 'charge@package',
        meta: {
            name: '课时包购买'
        },
        component: function component() {
            return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "HbSV"));
        }
    }, {
        path: '/package/detail',
        name: 'detail@package',
        meta: {
            name: '课时包购买'
        },
        component: function component() {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "HSzf"));
        }
    },
    // 充值反馈（学费，豆豆）是否成功
    {
        path: '/record/payback',
        name: 'payback@record',
        meta: { name: '充值反馈' },
        component: function component() {
            return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "WqZc"));
        }
    }, {
        path: '/record/period',
        name: 'period@record',
        meta: { name: '我的课时' },
        component: function component() {
            return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "N3OD"));
        }
    }, {
        path: '/record/purchase',
        name: 'purchase@record',
        meta: { name: '购买课时' },
        component: function component() {
            return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "X/Ms"));
        }
    }, {
        path: '/record/packagelist',
        name: 'packageList@record',
        meta: { name: '购买课时' },
        component: function component() {
            return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "f7q+"));
        }
    }, {
        path: '/record/bean',
        name: 'bean@record',
        meta: { name: '我的豆豆' },
        component: function component() {
            return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "xeKa"));
        }
    }, {
        path: '/record/integral',
        name: 'integral@record',
        meta: { name: '我的积分' },
        component: function component() {
            return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "sNYJ"));
        }
    },
    // 账号信息
    {
        path: '/user/basic',
        name: 'basic@user',
        meta: { name: '个人信息' },
        component: function component() {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "y7zk"));
        }
    }, {
        path: '/user/bind',
        name: 'bind@user',
        meta: { name: '绑定手机' },
        component: function component() {
            return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "UVZW"));
        }
    }, {
        path: '/user/password',
        name: 'password@user',
        meta: { name: '修改密码' },
        component: function component() {
            return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "Z4Pj"));
        }
    },
    // 404
    {
        path: '*',
        name: 'notFound',
        meta: { name: '404' },
        component: function component() {
            return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "/gvo"));
        }
    }]
});

router.beforeEach(function (to, from, next) {
    // if (to.meta.name) {
    //     document.title = '好分数辅导-' + to.meta.name;
    // } else {
    //     document.title = '好分数辅导';
    // }
    next();
});

exports.default = router;

/***/ }),

/***/ "4u6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("bIbA");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91425e3a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("I/Uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("k7XS")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91425e3a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91425e3a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5Yo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("zhMT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef15faa0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("tRYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("dmBM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef15faa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef15faa0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef15faa0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8q/s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _enum = __webpack_require__("vvAD");

var _enum2 = _interopRequireDefault(_enum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
    baseURL: '' + feConfig.api.base,
    timeout: '' + feConfig.api.timeout,
    withCredentials: true
});

instance.interceptors.request.use(function (config) {
    if (config.params && config.params.cookieStr) {
        console.log(config, 'config.........');
        document.cookie = config.params.cookieStr;
        delete config.params.cookieStr;
    }
    return config;
});

instance.interceptors.response.use(function (response) {
    if (response && _enum2.default.ErrorCode.CookieInvalid === response.data.code) {
        // 如果是移动端，cookie失效后触发InvalidCookie事件
        if (window.androidTest) {
            window.androidTest.InvalidCookie();
        }
        if (window.webkit) {
            window.webkit.messageHandlers.InvalidCookie.postMessage(null);
        }
        // 清空cookie值
        var d = new Date();
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
        document.cookie = feConfig.cookie.key + '= ;domain=' + feConfig.cookie.domain + ';expires=' + d.toUTCString();
        location.href = '/';
    }
    return response.data;
}, function (err) {
    if (err.response) {
        return _promise2.default.reject(err.response.data);
    }
    return _promise2.default.reject({ code: 1024, message: err.message });
});

function axios(options) {
    var cookie = null;
    if (options.cookie) {
        cookie = options.cookie.key + '=' + options.cookie.value;
        delete options.cookie;
    }
    var instance = _axios2.default.create((0, _assign2.default)({
        timeout: '' + feConfig.api.timeout
    }, options, cookie ? { headers: { Cookie: cookie } } : {}));
    instance.interceptors.response.use(function (response) {
        return response.data;
    }, function (err) {
        if (err.response) {
            return _promise2.default.reject(err.response.data);
        }
        return _promise2.default.reject({ code: 1024, message: err.message });
    });
    return instance;
}

function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    Vue.http = instance;
    Vue.axios = axios;
    Object.defineProperty(Vue.prototype, '$http', { value: instance });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

exports.default = plugin;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("kdwg")))

/***/ }),

/***/ "9XSc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 用户报名
var USER_POST_SIGNUP = exports.USER_POST_SIGNUP = 'USER_POST_SIGNUP';

// ----------------------
// 获取图片验证码
var USER_GET_CAPTCHA = exports.USER_GET_CAPTCHA = 'USER_GET_CAPTCHA';
// 验证图片验证码
var USER_VERIFY_CAPTCHA = exports.USER_VERIFY_CAPTCHA = 'USER_VERIFY_CAPTCHA';

var USER_POST_LOGIN = exports.USER_POST_LOGIN = 'USER_POST_LOGIN';
var USER_SET_PROFILE = exports.USER_SET_PROFILE = 'USER_SET_PROFILE';
// export const USER_SAVE_USERNAME = 'USER_SAVE_USERNAME';
var USER_GET_PROFILE = exports.USER_GET_PROFILE = 'USER_GET_PROFILE';

// 填写用户基本信息
var USER_SET_BASICINFO = exports.USER_SET_BASICINFO = 'USER_SET_BASICINFO';

// 获取账号通讯信息
var USER_GET_COMMUNICATION = exports.USER_GET_COMMUNICATION = 'USER_GET_COMMUNICATION';
var USER_SET_COMMUNICATION = exports.USER_SET_COMMUNICATION = 'USER_SET_COMMUNICATION';
// 退出
var USER_DELETE_LOGOUT = exports.USER_DELETE_LOGOUT = 'USER_DELETE_LOGOUT';

// 获取上传图片的 policy
var USER_GET_IMG_CONFIG = exports.USER_GET_IMG_CONFIG = 'USER_GET_IMG_CONFIG';
var USER_SET_IMG_CONFIG = exports.USER_SET_IMG_CONFIG = 'USER_SET_IMG_CONFIG';

// 重置状态
var USER_RESET_STATE = exports.USER_RESET_STATE = 'USER_RESET_STATE';

/***/ }),

/***/ "AL75":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "AkBd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_logo_web.422188a.png";

/***/ }),

/***/ "FAiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-top",on:{"click":_vm.scrollToTop}},[_vm._t("default",[_vm._m(0)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-top-content"},[_c('i',{staticClass:"back-top-icon el-icon-arrow-up"})])}]


/***/ }),

/***/ "Fnla":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppAvatar_vue__ = __webpack_require__("Tjph");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Avatar: __WEBPACK_IMPORTED_MODULE_1__AppAvatar_vue__["a" /* default */]
    },
    data: function data() {
        return {
            sidebarMap: []
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])({
        profile: function profile(state) {
            return state.user.profile;
        }
    }), {
        activeName: function activeName() {
            var name = this.$route.name;
            var targetName = '';
            if (name) {
                if (name.indexOf('@resource') > -1) {
                    targetName = 'coursewareList@resource';
                }
            }
            return targetName;
        }
    }),
    methods: {
        overShow: function overShow(index) {
            var item = document.getElementsByClassName('sidebar-item')[index];
            item.style.background = '#fcfcfc';
        },
        onhide: function onhide(index) {
            var item = document.getElementsByClassName('sidebar-item')[index];
            item.style.background = '#fff';
        }
    }
});

/***/ }),

/***/ "HclP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("PIWK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ddb565_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("IguY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ObDJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08ddb565"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ddb565_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ddb565_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I/Uo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",attrs:{"id":"app"}},[(_vm.isFullScreen)?[_c('router-view')]:[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"layout-container"},[_c('app-sidebar'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('app-footer')],_vm._v(" "),_c('app-back-top')],2)}
var staticRenderFns = []


/***/ }),

/***/ "I99j":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "IguY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-header",class:{'home-header-fixed': _vm.isFixing}},[_c('div',{staticClass:"home-header-wrap"},[_c('router-link',{attrs:{"to":{name:'schedule@course'}}},[_c('img',{staticClass:"home-header-logo",attrs:{"src":__webpack_require__("AkBd"),"alt":"好分数辅导logo"}})]),_vm._v(" "),_c('div',{staticClass:"home-header-content"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"home-header-nav"},[_c('li',{class:{'active': _vm.$route.name === 'home'}},[_c('router-link',{attrs:{"to":{name:'home'}}},[_vm._v("首页")])],1),_vm._v(" "),_c('li',{class:{'active-download': _vm.$route.name === 'download'}},[_c('router-link',{attrs:{"to":{name:'download'}}},[_vm._v("客户端下载")])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name === 'home' || _vm.$route.name === 'download'),expression:"$route.name === 'home' || $route.name === 'download'"}],staticClass:"move"})]),_vm._v(" "),(_vm.userInfo.name)?_c('div',{staticClass:"user"},[(_vm.userInfo.avatar)?_c('img',{staticClass:"photo",attrs:{"src":_vm.userInfo.avatar,"alt":"头像"}}):_c('img',{staticClass:"photo",attrs:{"src":__webpack_require__("AL75"),"alt":"头像"}}),_vm._v(" "),_c('span',[_vm._v("Hi")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userInfo.name)+"同学")]),_vm._v(" "),_c('ul',{staticClass:"home-header-menu"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'basic@user'}}},[_vm._v("个人中心")])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":_vm.quitLogin}},[_vm._v("退出登录")])])])]):_c('div',{staticClass:"home-header-option"},[_c('div',{staticClass:"home-header-login"},[_vm._v("\n                    登录\n                    "),_c('ul',{staticClass:"home-header-menu-btn"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'login@account', query: {userType: 2}}}},[_vm._v("学生登录")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'login@account', query: {userType: 3}}}},[_vm._v("家长登录")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.teacherUrlLogin,"target":"_blank"}},[_vm._v("教师登录")])])])]),_vm._v(" "),_c('span',{staticClass:"home-header-split"},[_vm._v("|")]),_vm._v(" "),_c('div',{staticClass:"home-header-register"},[_vm._v("\n                    注册\n                    "),_c('ul',{staticClass:"home-header-menu-btn"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'register@account', query: {userType: 2}}}},[_vm._v("注册学生")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'register@account', query: {userType: 3}}}},[_vm._v("注册家长")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.teacherUrlRegister,"target":"_blank"}},[_vm._v("注册老师")])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-header-phone"},[_c('i'),_vm._v("客服电话\n                "),_c('ul',{staticClass:"home-header-phone-con"},[_c('li',[_vm._v("\n                        电话1：4008-180-190\n                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                        电话2：010-80455369\n                    ")])])])}]


/***/ }),

/***/ "LOKH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations, _actions;

var _types_payment = __webpack_require__("VLfe");

var TypesPayment = _interopRequireWildcard(_types_payment);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    state: {
        goods: {},
        miniAmount: 0, // 小程序订单金额
        packageMoneyInfo: {}
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, TypesPayment.PAYMENT_SET_GOODS, function (state, payload) {
        state.goods = payload || {};
    }), (0, _defineProperty3.default)(_mutations, TypesPayment.SMALLROUTINE_AMOUNT_GET, function (state, params) {
        state.miniAmount = params.amount;
    }), (0, _defineProperty3.default)(_mutations, TypesPayment.PAYMENT_PACKAGE_GOOD, function (state, params) {
        state.packageMoneyInfo = params;
    }), _mutations),
    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, TypesPayment.PAYMENT_GET_GOODS, function (ctx) {
        return _vue2.default.http.get('/v1/payments/goods-list').then(function (resp) {
            return _vue2.default.checkResp(resp, {});
        }).then(function (data) {
            ctx.commit(TypesPayment.PAYMENT_SET_GOODS, data);
            return data;
        }).catch(function (err) {
            ctx.commit(TypesPayment.PAYMENT_SET_GOODS, null);
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesPayment.PAYMENT_READY_INfO, function (ctx, _ref) {
        var goodsType = _ref.goodsType,
            goodsNo = _ref.goodsNo,
            copies = _ref.copies,
            payThrough = _ref.payThrough,
            deviceType = _ref.deviceType;

        return _vue2.default.http.post('/v1/payments', { goodsType: goodsType, goodsNo: goodsNo, copies: copies, payThrough: payThrough, deviceType: deviceType }).then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            return data;
        }).catch(function (err) {
            throw err;
        });
    }), _actions)
};

/***/ }),

/***/ "MYt6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAMAAACsAtiWAAAByFBMVEUAAAD/JwD/WQD/RgD/TAD/XAD/SQD/UQD/TQD/OgD/VQD/SwD/SwD/TwD/RwD/KgD/VwD/PAD/SgD/RAD/UQD/LAD/KAD/PwD/VgD/PQD/TQD/SAD/QQD/RAD/RAD/NAD/RgD/NQD/MQD/NwD/WAD/SwD/KAD/OwD/LwD/MQD/QQD/JwD/UQD/UwD/UAD/JwD/RgD/LQD/UgD/SQD/WQD/RgD/OwD/WAD/VAD/IwD/JwD/7un/////JwD/VwD/VQD/g2b/fF3/m4T/TAD/t5L/UgD/SQD/QgD/RQD/KQD/Tyb/UAH/TgH/k3f/Vy7/OwD/5+H/im7/PwD/KwD//v3/2M3/oIj/fl//NQD/MgD/LwD/6+X/xbf/t6X/dFP/XDX/RwH/OAD/3NP/w7T/v6X/tJ//lXv/eVn/aUb/Uyv/+PX/5t3/5dn/1Mn/18j/1MT/zLj/ybP/uZn/qpX/p5D/kHX/iGr/eEX/ZUD/fT7/cj7/Yz7/eDf/ai//XB7/XQ//4tT/zcD/wbL/w63/vZ//spH/rob/qob/q4T/ooP/nHv/knr/pHj/m2r/h2r/kmX/lWD/f2D/hlv/czj/cDP/Xy//ciz/NQf6R1PeAAAAO3RSTlMAq20SDAbs4oBEPBYK/f369727r4p3a1xFLicc+O7r6+nk3tvZ18vHw7q1sa2loJ2Yknp3c3FnYlgkIekWYt0AAAIzSURBVDjLjdTnV9pQAAXw16pMrXt37713kjdIk7CCICMVFKwUEbWuOuru3nv+u33vAIlCyPF+4Et+J7nh5D5QGacTWMfdPija+yxA461Dioykpva6GqD+xlGvogS3paB44LzbBPR22ORRr7IyNbMaFGWvcqbbuFbn6rl7/aJdFGXZuznH8xz3eJOSwYFHx85d6+y6D0BfC0SSFAhSsjLP84xQtMbIw6Fk1Cc4wX6IGAn8fjfNACMsMx//DDAiCPsogaufF2Yn+XK4csLZRCRTJOhB8ZpBjHj2TKAV8VXdJcZIyopkv2Z5buTHiEUXFas8FyERC7KEl3humSzXelAsFcZ5HI5raS0+Zk6eYhzyhzAp+AuEJExJpEToDyHY9H95kvDgCW09k1/X1PHhyrsYGcaEvrJF3XA4l08vxuOsrvGgOxC+LdelmfD7nxGi1/3kE64AF0TfS3UNotdNC0IXcEO4odf1eEgmlFZVvW5BEHoBOInQc6PuS0xyRtsXUaEZAHAToS+13kiLChfYAloQnNYJNx4Z08Xsv6jvHqDpQNJGzPSTyiSjp4sztUvSezOiDiWbS9PtoSN5XU0W6Ug6QSkOuqP5SpKjOzoL9FwKBANvdpMPdI3HgZGGNjrYb5MGmfpJB3ukHuw0l+mmt+b0TW/RTZ9oBLvjEOnZsfYqxnOphV/sZGgFVXGdokYZ3f6L2Ply8DYwSYPD5lVkiNgp1cpqmKLutsMINdmuUmCR/n5Qkf+KYAtbHhjA4wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "NXrx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAMAAACsAtiWAAACAVBMVEUAAAD/JwD/WQD/RgD/XAD/TQD/WAD/SwD/TgD/KgD/RAD/SwD/TgD/NAD/QgD/NAD/UQD/TwD/LAD/KAD/PwD/TAD/NQD/PQD/TQD/TgD/QwD/PwD/VwD/QQD/VwD/SAD/NAD/RgD/NQD/VgD/WAD/SwD/KAD/OwD/LwD/UAD/QQD/JwD/RgD/QgD/UQD/JwD/RgD/LQD/VwD/SQD/WQD/RgD/VwD/OwD/WAD/VAD/TgD/IwD/JwD/RAD/TAD//wD/7un/////VgD/JwD/dl3/fWb/SgD/t5L/m4X/TwD/TQD/RwD/QgD/UgD/RQD/KQD/VAD/UQH/OwD/KwD/0Mb/kHz/iXP/eF7/PwD/NQD/MgD/LwD//Pv/7uj/6eX/39n/08n/g2z/gWn/e2L/clf/Sin/OAD//v3/+PX/9fL/7OX/59//49z/5dr/3dX/18f/xLj/yrT/u63/qJb/oIz/lID/i3b/fmf/czz/Wjr/5N7/2dH/zcH/x73/wrT/tqj/vqX/sqT/rp7/uZn/moT/lHj/h27/lGL/a1D/eEX/fT7/eDf/XTH/ai//RiX/XQ//Vwf/4tT/2dD/zLn/w63/wKb/vZ//tp//spH/qZD/m4n/rob/qob/q4T/ooP/nHv/pHj/m2r/fmD/hlv/Z0v/cDP/Uy7/ciz/XyD/Whz/NQeLolCJAAAAQHRSTlMAq20SBn0/Fgv67ezk3by8o4Z3a1xHQy4nDQn++Pj17Ovp5N/Z18vHw7q1sa+urZ2Ykox3c3FsZ2JYOyQhHhsBdJRILQAAAm1JREFUOMud1FV32zAYBmBtZWZYx8zMbMtSNofdUNemDa+UJmk4xbVdGcfMvF852U7mBpyLvhf2hZ5j6ztHr0BmmptA/pSc7lBWtuYBbZfL1Sq9hj1VIANKL+7XqtXKdQ2rVJ0oyQFa6ipUKq16cci/xCoVWvXRRmmtoLj4etGZSqVCodKuPqNpinqxSkhH+8MDNefrG24B0LoH6jXk24QsDtMkFMmjOE8edHYZdEwzuAIFwv14P8QDQoT4P62084RhtoHtEC59nvH30alQqQxOhOcSSXJPXJOIlMdbJNaezeS+LouMR2KWaLBbnljDGGOEUGTgP8n8URDHJr32kAVNy5G+GA7w251ElkGZH9mw08qTAQsyyhA7jopDO1FAhvRgTPHEh9CozF56TfhtP02NmNBct9zQNozcTteCm2xFjvRHPB7P2prH7E0b+hqE75LC58CWhUTiuxu5xpJkVsecBcUQzouCcuCo3Wsy2wMO5PKJxM0wDaAEwmWRTGMzRdtMZiNlc6KwSH4yTAsAh6D+iTCPA4+TwU3mpxQVRC5hpjEDUwYAuAT1X4S9YtxDXsYJsjSK0AhPvhqYk3wDduk3hGM7NSUdqVCIfxr/GnQ3AckFvWa5N9ep617pMhwRW3hQw33IRWY7u8qS1W3ScOzLbPKGlKQeJFPHsdxwJnlFenQMpHK3lmW51+nkI2ljFZBSeJwUdr5PIoPfSGH3lYLNppZ0+rfU6T+k01VtID1F/M0Qf26lqYGZOLlFdtaArNw4zN8vqvVfG/z9svsqyJHCor2EQHKRKRTVO3IAATVWl0PIVZwjIE/u3AYZ+QcPcyjpZUy6XwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "ObDJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PIWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BaseUrl = feConfig.teacherApi.base;
/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    props: {
        isFixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            isFixing: false,
            teacherUrlLogin: BaseUrl + '/account/login',
            teacherUrlRegister: BaseUrl + '/account/register'
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
        userInfo: function userInfo(state) {
            return state.user.profile;
        }
    })),
    watch: {
        isFixed: function isFixed(newValue) {
            this.isFixing = !!newValue;
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['USER_DELETE_LOGOUT']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapMutations"])(['USER_RESET_STATE']), {
        quitLogin: function quitLogin() {
            var _this = this;

            this.USER_DELETE_LOGOUT().then(function () {
                _this.$router.push({ name: 'home' });
                _this.USER_RESET_STATE();
            });
        }
    })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("kdwg")))

/***/ }),

/***/ "PfMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showUrl)?_c('img',{ref:"avatarImg",staticClass:"current-img",attrs:{"src":_vm.showUrl,"alt":"头像"},on:{"error":_vm.handleError}}):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size}},[_c('g',[(_vm.type =='circle')?[_c('circle',{attrs:{"cx":_vm.size/2,"cy":_vm.size/2,"r":_vm.size/2,"fill":_vm.bg}})]:[_c('rect',{attrs:{"x":"0","y":"0","fill":_vm.bg,"width":_vm.size,"height":_vm.size}})],_vm._v(" "),_c('text',{style:(_vm.styles),attrs:{"y":"50%","x":"50%","fill":_vm.color,"text-anchor":"middle","dominant-baseline":"central"}},[_vm._v("\n            "+_vm._s(_vm.showName)+"\n        ")])],2)])}
var staticRenderFns = []


/***/ }),

/***/ "Rra/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

__webpack_require__("j1ja");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("4u6v");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("4Cf5");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("+P7g");

var _store2 = _interopRequireDefault(_store);

var _vuexRouterSync = __webpack_require__("9JMe");

var _axios = __webpack_require__("8q/s");

var _axios2 = _interopRequireDefault(_axios);

var _checkResp = __webpack_require__("V9j6");

var _checkResp2 = _interopRequireDefault(_checkResp);

var _handleError = __webpack_require__("28he");

var _handleError2 = _interopRequireDefault(_handleError);

var _elementUi = __webpack_require__("zL8q");

var _elementUi2 = _interopRequireDefault(_elementUi);

var _isMobile = __webpack_require__("bTlQ");

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 异步追加 finally
/* eslint-disable */
'use strict';
_promise2.default.prototype.finally = function (t) {
    var n = this.constructor;return this.then(function (r) {
        return n.resolve(t()).then(function () {
            return r;
        });
    }, function (r) {
        return n.resolve(t()).then(function () {
            throw r;
        });
    });
};

// sync the router with the vuex store.
// this registers `store.state.route`
(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_vue2.default.use(_axios2.default);
_vue2.default.use(_checkResp2.default);
_vue2.default.use(_handleError2.default);
_vue2.default.use(_elementUi2.default);
_vue2.default.use(_isMobile2.default);

_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
    el: '#app',
    router: _router2.default,
    store: _store2.default,
    components: { App: _App2.default },
    template: '<App/>'
});

/***/ }),

/***/ "SCEn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAoCAMAAACsAtiWAAABwlBMVEUAAAD/JgD/WAD/RAD/RgD/TAD/QwD/MgD/TgD/JwD/VwD/UQD/MwD/PwD/SwD/KQD/QAD/VgD/NAD/TwD/QwD/QAD/NgD/TwD/RAD/KAD/QgD/UQD/OgD/LgD/JwD/RAD/VwD/SgD/UgD/JgD/RAD/UQD/SQD/LQD/VwD/RgD/KwD/VwD/RgD/LAD/UwD/OQD/VQD/NgD/VgD/TAD/KgD/TQD/VwD/KQD/JwD/QQD//wD/7un/////VgD/JwD/SAD/t5L/m4T/UgD/QwD/bkz/TAD/KQD/UAH/RQD/aET/VAD/SwD/+vj/TwD/PwD/NwD/LAD/QRX/OwD/6+X/5dv/a0j/MgD/LwD/wK//k3j/clD/7uj/1cn/0sX/xbb/yrT/t6X/v6T/up7/lXv/czz/WTL/UCj/XAz/NQL//Pr/+PX/2Mf/zcD/wrL/oor/ln3/ekH/ezv/XDT/cTD/aS//RRn/59//5t7/4tT/2M7/2M3/zLn/rpv/uJb/spH/qpH/rob/qob/q4T/o4T/m3n/pHj/lnj/iW3/m2r/kmX/lWD/fmD/hlv/dVf/d0j/YTz/eDT/Xy7/XyD/Wx3/Rwf/PQI6Q4XBAAAAO3RSTlMAzqsSC/n99iL++t3c2b6NdGs2KykY8ezs5+Xk5OLT0cvHw8K+uba2sq+fnpmYkYp7enRoXFpGPi4eATyOxLQAAAIBSURBVDjLxdRXc9pAFAXgm1DcWxyn9957l1ZKVJARCCSDY2wMGEJx707vvff839wVVgh4xfjBMz4v0sx+I11p5lyoTWcn1M/mHRHVt6kO8Bz3R0RdUvf2uICeI6Isy2pJMtTetkYGuLw/JIq98tf4xKyh4s2u85Wzxq4LZw7v9KlULD7ieY7LLiKJ9EUbWo+e7rgGcIUQXZI0Qw2FZjM8TwmXzOYpid4eMANNl2BjmWgLL+IUILEz/PpH3ygSQdhAydybJxPjvBPOyb2p6XeFZXLTOXVIJbfWhgRWQdZtlvDjBzZJph+6kPCQtTSJB7HBYH+cScJ3CtaSkqYCCWMWFIpS/Kb0T1GRYL2IiqHUjBIszlPBIiMohvnwTMGygomqjz5JyPMyQUEfpljWCOdkMCAchC5CPtpkLBWzr7HpNPcvXwShA7oJ+e7+64qCcBWgmej33cikKTQBwDGiv3cjn0xhD20A0UtxNkmNmgG7mvt0aY5JkvMD5vZyTZsl6SWLvMUGXAc757AkuZXkGfboBCznAPYoU0ty2KPd4ORGi2ZoT6vJqz/RaANU4t2Khf0wXiF3P9NOe+B/04K1/5lxSPYXdnqLF6rTTjdDPjHGc7Fcnm6GVliRiz408u/SAqH7xX8WGPG245YScU8YIbGNjsFEp7b5CdF8hzz1d2Y31OQvXuoG/YRT1LQAAAAASUVORK5CYII="

/***/ }),

/***/ "TJw1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tjph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAvatar_vue__ = __webpack_require__("tqoN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54335907_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAvatar_vue__ = __webpack_require__("PfMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54335907_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAvatar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54335907_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAvatar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V9j6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 统一处理API返回的数据
 * @param {*} resp: axios返回的对象
 * @param {*} emptyDefault（可选）: 指定当code === 1 时应该返回什么。
 */
var checkResp = function checkResp(resp, emptyDefault) {
    if (resp && (resp.code === 0 || resp.code === 1)) {
        if (resp.code === 1 && emptyDefault) {
            return emptyDefault;
        }
        return resp.data;
    }
    return _promise2.default.reject(resp);
};

exports.default = {
    install: function install(Vue) {
        Vue.checkResp = checkResp;
        Object.defineProperty(Vue.prototype, '$checkResp', { value: Vue.checkResp });
    }
};

/***/ }),

/***/ "VLfe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// 获取获取商品列表(学费和豆豆)
var PAYMENT_GET_GOODS = exports.PAYMENT_GET_GOODS = 'PAYMENT_GET_GOODS';
var PAYMENT_SET_GOODS = exports.PAYMENT_SET_GOODS = 'PAYMENT_SET_GOODS';
/* eslint-disable */
// 发起支付
var PAYMENT_READY_INfO = exports.PAYMENT_READY_INfO = 'PAYMENT_READY_INfO';

// 小程序订单金额获取
var SMALLROUTINE_AMOUNT_GET = exports.SMALLROUTINE_AMOUNT_GET = 'SMALLROUTINE_AMOUNT_GET';

// 课时包支付
var PAYMENT_PACKAGE_GOOD = exports.PAYMENT_PACKAGE_GOOD = 'PAYMENT_PACKAGE_GOOD';

/***/ }),

/***/ "XdCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__("Fnla");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6630d5dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__("j7l7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TJw1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6630d5dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6630d5dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6630d5dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZJhb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bIbA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppBackTop__ = __webpack_require__("yeTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppHeader__ = __webpack_require__("HclP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppSidebar__ = __webpack_require__("XdCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppFooter__ = __webpack_require__("5Yo1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_js_cookie__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'App',
    components: {
        AppBackTop: __WEBPACK_IMPORTED_MODULE_3__components_AppBackTop__["a" /* default */],
        AppHeader: __WEBPACK_IMPORTED_MODULE_4__components_AppHeader__["a" /* default */],
        AppSidebar: __WEBPACK_IMPORTED_MODULE_5__components_AppSidebar__["a" /* default */],
        AppFooter: __WEBPACK_IMPORTED_MODULE_6__components_AppFooter__["a" /* default */]
    },
    computed: {
        isFullScreen: function isFullScreen() {
            return !!this.$route.meta.isFullScreen || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$route.meta).length;
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['USER_GET_PROFILE'])),
    created: function created() {
        if (__WEBPACK_IMPORTED_MODULE_7_js_cookie___default.a.get(feConfig.cookie.key)) {
            this.USER_GET_PROFILE();
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("kdwg")))

/***/ }),

/***/ "bTlQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ua = navigator.userAgent.toLowerCase() || window.navigator.userAgent.toLowerCase();
var isMobile = ua.indexOf('mobi') !== -1;

function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    Object.defineProperty(Vue.prototype, '$isMobile', { value: isMobile });
    // 向前兼容
    Vue.isMobile = isMobile;
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),

/***/ "c2Da":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_qr_sc.7fe23a6.png";

/***/ }),

/***/ "cDbO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(feConfig) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _mutations, _actions;

var _types_user = __webpack_require__("9XSc");

var TypesUser = _interopRequireWildcard(_types_user);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 这个方案比 _.cloneDeep()效率高；
var getDefaultState = function getDefaultState() {
    return {
        profile: {},
        communicationInfo: { checkBind: false },
        imgConfig: {}
        // username: ''
    };
};

exports.default = {
    state: getDefaultState(),
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, TypesUser.USER_SET_PROFILE, function (state, payload) {
        state.profile = payload || {};
    }), (0, _defineProperty3.default)(_mutations, TypesUser.USER_SET_COMMUNICATION, function (state, payload) {
        if (payload) {
            state.communicationInfo = (0, _assign2.default)({}, payload, { checkBind: true });
        } else {
            state.communicationInfo = { checkBind: false };
        }
    }), (0, _defineProperty3.default)(_mutations, TypesUser.USER_SET_IMG_CONFIG, function (state, payload) {
        state.imgConfig = payload || {};
    }), (0, _defineProperty3.default)(_mutations, TypesUser.USER_RESET_STATE, function (state) {
        var newState = getDefaultState();
        // 为保留响应式，需要这么处理：
        (0, _keys2.default)(newState).forEach(function (key) {
            state[key] = newState[key];
        });
    }), _mutations),
    actions: (_actions = {}, (0, _defineProperty3.default)(_actions, TypesUser.USER_GET_CAPTCHA, function (ctx, _ref) {
        var captchaId = _ref.captchaId;

        return _vue2.default.axios({ baseURL: '' + feConfig.api.captcha }).post('/captcha', {
            apiKey: 'hfs',
            captchaId: captchaId
        }).then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            return data;
        }).catch(function (err) {
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_VERIFY_CAPTCHA, function (ctx, _ref2) {
        var captchaId = _ref2.captchaId,
            inputText = _ref2.inputText;

        return _vue2.default.axios({ baseURL: '' + feConfig.api.captcha }).get('/captcha/match-result', {
            params: { apiKey: 'hfs', captchaId: captchaId, inputText: inputText }
        }).then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            return data;
        }).catch(function (err) {
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_POST_SIGNUP, function (ctx, _ref3) {
        var name = _ref3.name,
            phoneNumber = _ref3.phoneNumber,
            grade = _ref3.grade,
            subject = _ref3.subject;

        return _vue2.default.http.post('/v1/appointments', {
            flag: 'hfsfd-ow',
            name: name,
            phone: phoneNumber,
            grade: grade,
            subject: subject,
            pageFlag: '官网报名'
        }).then(function (resp) {
            if (resp.code === 0) {
                return {
                    success: true
                };
            } else if (resp.code === 1004 || resp.code === 3101) {
                return {
                    hasSignUp: true
                };
            } else {
                return _promise2.default.reject({
                    code: resp.code,
                    msg: resp.msg
                });
            }
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_POST_LOGIN, function (ctx, _ref4) {
        var username = _ref4.username,
            password = _ref4.password,
            userType = _ref4.userType,
            deviceType = _ref4.deviceType,
            reCaptcha = _ref4.reCaptcha,
            captchaId = _ref4.captchaId;

        return _vue2.default.http.post('/v2/users/sessions', {
            username: username,
            password: password,
            userType: userType,
            deviceType: deviceType,
            reCaptcha: reCaptcha,
            captchaId: captchaId
        }).then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            ctx.commit(TypesUser.USER_SET_PROFILE, data);
            // ctx.commit(TypesUser.USER_SAVE_USERNAME, username);
            return data;
        }).catch(function (err) {
            ctx.commit(TypesUser.USER_SET_PROFILE, null);
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_GET_PROFILE, function (ctx) {
        return _vue2.default.http.get('/v1/user-center/basic-info').then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            ctx.commit(TypesUser.USER_SET_PROFILE, data);
            return data;
        }).catch(function (err) {
            ctx.commit(TypesUser.USER_SET_PROFILE, null);
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_SET_BASICINFO, function (ctx, _ref5) {
        var avatar = _ref5.avatar,
            name = _ref5.name,
            sex = _ref5.sex,
            grade = _ref5.grade,
            locale = _ref5.locale,
            schoolName = _ref5.schoolName;

        return _vue2.default.http.post('/v1/user-center/basic-info', { avatar: avatar, name: name, sex: sex, grade: grade, locale: locale, schoolName: schoolName }).then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            return data;
        }).catch(function (err) {
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_GET_COMMUNICATION, function (ctx) {
        return _vue2.default.http.get('/v1/user-center/communication-info').then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            ctx.commit(TypesUser.USER_SET_COMMUNICATION, data);
            return data;
        }).catch(function (err) {
            ctx.commit(TypesUser.USER_SET_COMMUNICATION, null);
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_DELETE_LOGOUT, function (ctx) {
        return _vue2.default.http.delete('/v1/users/sessions').then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (data) {
            ctx.commit(TypesUser.USER_SET_PROFILE, null);
            return data;
        }).catch(function (err) {
            ctx.commit(TypesUser.USER_SET_PROFILE, null);
            throw err;
        });
    }), (0, _defineProperty3.default)(_actions, TypesUser.USER_GET_IMG_CONFIG, function (ctx) {
        return _vue2.default.axios({ baseURL: '' + feConfig.api.base, withCredentials: true }).get('/v1/config/ks3/authorization/post-policy').then(function (resp) {
            return _vue2.default.checkResp(resp);
        }).then(function (config) {
            ctx.commit(TypesUser.USER_SET_IMG_CONFIG, config);
            return config;
        }).catch(function (err) {
            ctx.commit(TypesUser.USER_SET_IMG_CONFIG, null);
            throw err;
        });
    }), _actions)
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("kdwg")))

/***/ }),

/***/ "dmBM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ghFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        visibilityHeight: {
            type: Number,
            default: 400
        }
    },
    data: function data() {
        return {
            visible: false
        };
    },
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScroll, false);
        window.addEventListener('resize', this.handleScroll, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, false);
        window.removeEventListener('resize', this.handleScroll, false);
    },

    methods: {
        getScroll: function getScroll(w, top) {
            var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
            var method = 'scroll' + (top ? 'Top' : 'Left');
            if (typeof ret !== 'number') {
                var d = w.document;
                // ie6,7,8 standard mode
                ret = d.documentElement[method];
                if (typeof ret !== 'number') {
                    // quirks mode
                    ret = d.body[method];
                }
            }
            return ret;
        },
        handleScroll: function handleScroll() {
            var scrollTop = this.getScroll(window, true);
            this.visible = scrollTop > this.visibilityHeight;
        },
        scrollToTop: function scrollToTop() {
            var _this = this;

            var timer = setInterval(function () {
                var scrollTop = _this.getScroll(window, true);
                var ispeed = Math.floor(-scrollTop / 6);
                window.scrollTo(0, scrollTop + ispeed);
                if (scrollTop === 0) {
                    clearInterval(timer);
                }
            }, 20);
            this.$emit('on-click');
        }
    }
});

/***/ }),

/***/ "j7l7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-sidebar"},[_c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar-item",on:{"mouseenter":function($event){_vm.overShow(0)},"mouseleave":function($event){_vm.onhide(0)}}},[_c('h4',{staticClass:"user-course"},[_vm._v("我的辅导")]),_vm._v(" "),_c('ul',[_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'schedule@course'},attrs:{"to":{name:'schedule@course'}}},[_vm._v("我的课表")])],1),_vm._v(" "),_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'video@course'},attrs:{"to":{name:'video@course'}}},[_vm._v("视频回放")])],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-item",on:{"mouseenter":function($event){_vm.overShow(1)},"mouseleave":function($event){_vm.onhide(1)}}},[_c('h4',{staticClass:"user-record"},[_vm._v("消费记录")]),_vm._v(" "),_c('ul',[_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'purchase@record' || _vm.$route.name === 'packageList@record' || _vm.$route.name === 'detail@package'},attrs:{"to":{name:'purchase@record'}}},[_vm._v("购买课时")])],1),_vm._v(" "),_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'period@record'},attrs:{"to":{name:'period@record'}}},[_vm._v("我的课时")])],1),_vm._v(" "),_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'tuition@record'},attrs:{"to":{name:'tuition@record'}}},[_vm._v("我的余额")])],1),_vm._v(" "),_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'bean@record'},attrs:{"to":{name:'bean@record'}}},[_vm._v("我的豆豆")])],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-item",on:{"mouseenter":function($event){_vm.overShow(2)},"mouseleave":function($event){_vm.onhide(2)}}},[_c('h4',{staticClass:"user-account"},[_vm._v("账号信息")]),_vm._v(" "),_c('ul',[_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'basic@user'},attrs:{"to":{name:'basic@user'}}},[_vm._v("个人信息")])],1),_vm._v(" "),_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'bind@user'},attrs:{"to":{name:'bind@user'}}},[_vm._v("绑定手机")])],1),_vm._v(" "),_c('li',[_c('i'),_c('router-link',{class:{active: _vm.$route.name === 'password@user'},attrs:{"to":{name:'password@user'}}},[_vm._v("修改密码")])],1)])])])])}
var staticRenderFns = []


/***/ }),

/***/ "jnMg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAclBMVEUAAADn5+fn5+fm5ubn5+fn5+fn5+fp6enn5+fp6ent7e3n5+fo6Ojn5+f////n5+f////n5+fn5+fn5+fn5+fn5+fo6Ojm5ubq6urn5+fm5ubn5+fn5+fm5ubq6urt7e3m5ubn5+fm5ubo6Ojy8vLm5uarTa7lAAAAJXRSTlMA9IDZqnHTIsAWDKWDUgjoA+zhfPmXYlMnxrCeRT41G862XFgTU9ZWyQAAAUlJREFUOMudldmOwyAMRU0okIWk2dqky3RW//8vjgKIQAGh9j4ZcYSDuXbAl2BNSQmhZcMEJFVJjo64rKJYXRB8EinqkGuPGNGxfeYKTKjwsO6ASR06B1RckgzyZrO3qFUyRqJka+qi7zssAPATBY+1k5is+mvTySud7gZgV4HI9kZSx2fQOmFMEgC4Dn8NeI6CHECYkBnwilEJYCY6aa7BuJjdoaakCTVQotFjA6cUWAJFN/c9BVKwdZuV9y8JkADxXSKGFEj3xbKRH3Midbkvhk9FmjPHb+Jexivcl3LJytVOB9XNLQ/zzNyrxpgGHNXp93EvuMCQhF6YRvnj9gmBe+TVEOB7hFubWfE11sYyYlXC+p3r6W7csAfpYtHJ7cM6HCajfHTbzmSbK+0tQi909ts1PwBeHCn5IfXG2MsP0vxofnvY538f/3MZkWnscS7RAAAAAElFTkSuQmCC"

/***/ }),

/***/ "k7XS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdwg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    isProduction: true,
    api: {
        base: 'https://hfsfd-be.haofenshu.com',
        captcha: 'https://hfs2-avatar.yunxiao.com',
        slideCaptcha: 'https://hfsfd3-captcha.haofenshu.com',
        timeout: 200000
    },
    hfsStoreApi: 'https://fd-store-serv-wan.haofenshu.com',
    ssoApi: {
        base: 'http://sso.yunxiao.com',
        timeout: 200000
    },
    teacherApi: {
        base: 'http://fudaojs.haofenshu.com'
    },
    appTeacherApi: {
        base: 'https://hfsfd-teacher.haofenshu.com'
    },
    imgService: {
        prefix: 'hfsfd'
    },
    cookie: {
        key: 'hfsfd-session-id',
        domain: '.haofenshu.com'
    },
    domain: 'https://fudao.haofenshu.com',
    CmbcUrl: 'https://pay.creditcard.cmbc.com.cn/pay/cmbcApply/perpaidOrder',
    jiankeapp: {
        jianketiaozhuan: 'fudaotool://tool.fudao.aiyunxiao.com/start?pageType=2&timetableId=',
        iosDownload: 'https://itunes.apple.com/cn/app/id1508095015',
        androidDownload: 'https://appvm.yunxiao.com/dl/5e816951969df601c7b632c4'
    },
    trackPoint: {
        feMonitor: '//fe-monitor.iyunxiao.com', // trackPonit 配置获取地址
        projectId: '5da18b6b00000561022c2539', // 项目 ID
        baseURL: '//fe-monitor.iyunxiao.com', // 上报地址
        time: 5000, // 上报间隔
        sKey: 'FD_HFS_STUDENT_TrackPoint', // 本地 storge 缓存 key，可根据项目修改
        eventType: ['click'] // 事件类型
    },
    agreementUrl: 'https://fudaomkt.haofenshu.com'
};

/***/ }),

/***/ "tRYm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowPromise),expression:"isShowPromise"}],staticClass:"promise"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"app-footer",class:{
        'app-footer--simple':_vm.simple
    }},[_c('div',{staticClass:"app-footer__container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.simple),expression:"!simple"}],staticClass:"footer-main"},[_c('div',{staticClass:"hot-line"},[_c('span',{staticClass:"hot-line__text"},[_vm._v("学习服务热线")]),_vm._v(" "),_c('span',{staticClass:"hot-line__phone"},[_vm._v("4008-180-190")]),_vm._v(" "),_c('router-link',{staticClass:"hot-line__publicity",attrs:{"to":{name:'publicityCommitment'}}},[_vm._v("线上培训机构备案承诺公示")]),_vm._v(" "),_c('span',{staticClass:"hot-line__warning"},[_vm._v("投诉举报电话：4008-180-190")])],1),_vm._v(" "),_c('ul',{staticClass:"link-list link-list--1"},[_c('li',{staticClass:"link-list__title"},[_vm._v("服务与支持")]),_vm._v(" "),_c('li',{staticClass:"link-list__item"},[_c('router-link',{staticClass:"link-list__link",attrs:{"to":{name:'user-agreement'},"target":"_blank"}},[_vm._v("用户协议/")]),_vm._v(" "),_c('router-link',{staticClass:"link-list__link",attrs:{"to":{name:'privacy-agreement'},"target":"_blank"}},[_vm._v("隐私政策/")]),_vm._v(" "),_c('router-link',{staticClass:"link-list__link",attrs:{"to":{name:'child-privary-policy'},"target":"_blank"}},[_vm._v("儿童隐私政策")])],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('el-dialog',{staticClass:"price-dialog",attrs:{"title":"课时包介绍","width":"580px","visible":_vm.PriceDialog},on:{"update:visible":function($event){_vm.PriceDialog=$event}}},[_c('p',{staticClass:"one-one"},[_vm._v("好分数辅导1对1价格表")]),_vm._v(" "),_c('div',{staticClass:"table"},[_c('div',{staticClass:"tr"},[_c('div',{staticClass:"th"},[_vm._v("年级")]),_vm._v(" "),_c('div',{staticClass:"th"},[_vm._v("基础课时价格")]),_vm._v(" "),_c('div',{staticClass:"th"},[_vm._v("高级课时价格")])]),_vm._v(" "),_vm._l((_vm.priceContent),function(item){return _c('div',{key:item.grade,staticClass:"tr"},[_c('div',{staticClass:"td"},[_vm._v(_vm._s(item.gradeStr))]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v(_vm._s(item.basicPrice))]),_vm._v(" "),_c('div',{staticClass:"td"},[_vm._v(_vm._s(item.seniorPrice))])])})],2)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promise-item"},[_c('img',{staticClass:"promise-item-pic",attrs:{"src":__webpack_require__("SCEn"),"alt":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px"}},[_c('div',{staticClass:"promise-item-name"},[_vm._v("免费试听承诺")]),_vm._v(" "),_c('div',{staticClass:"promise-item-text"},[_vm._v("首节测评课免费试听"),_c('br'),_vm._v("满意后再付费上课")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promise-item",staticStyle:{"margin-left":"23px"}},[_c('img',{staticClass:"promise-item-pic",attrs:{"src":__webpack_require__("NXrx"),"alt":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px"}},[_c('div',{staticClass:"promise-item-name"},[_vm._v("随时换老师承诺")]),_vm._v(" "),_c('div',{staticClass:"promise-item-text"},[_vm._v("任何时候对老师不满意"),_c('br'),_vm._v("均可申请更换老师")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promise-item",staticStyle:{"margin-left":"18px"}},[_c('img',{staticClass:"promise-item-pic",attrs:{"src":__webpack_require__("MYt6"),"alt":""}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"20px"}},[_c('div',{staticClass:"promise-item-name"},[_vm._v("效果不满意，退余额")]),_vm._v(" "),_c('div',{staticClass:"promise-item-text"},[_vm._v("课程不满意，支持退款，退款会扣除已上课时费和服务费")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"link-list link-list--2"},[_c('li',{staticClass:"link-list__title"},[_vm._v("友情链接")]),_vm._v(" "),_c('li',{staticClass:"link-list__item"},[_c('a',{staticClass:"link-list__link",attrs:{"href":"http://www.yunxiao.com/","target":"_blank"}},[_vm._v("云校官网")])]),_vm._v(" "),_c('li',{staticClass:"link-list__item"},[_c('a',{staticClass:"link-list__link",attrs:{"href":"http://paike.yunxiao.com/","target":"_blank"}},[_vm._v("云校排课")])]),_vm._v(" "),_c('li',{staticClass:"link-list__item"},[_c('a',{staticClass:"link-list__link",attrs:{"href":"http://bbs.yunxiao.com/","target":"_blank"}},[_vm._v("云校论坛")])]),_vm._v(" "),_c('li',{staticClass:"link-list__item"},[_c('a',{staticClass:"link-list__link",attrs:{"href":"https://hfs.yunxiao.com/","target":"_blank"}},[_vm._v("好分数")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-codes"},[_c('div',{staticClass:"qr-codes__item"},[_c('img',{staticClass:"qr-codes__img",attrs:{"src":__webpack_require__("c2Da"),"alt":"辅导商城小程序"}}),_vm._v(" "),_c('span',{staticClass:"qr-codes__text"},[_vm._v("辅导商城小程序")])]),_vm._v(" "),_c('div',{staticClass:"qr-codes__item"},[_c('img',{staticClass:"qr-codes__img",attrs:{"src":__webpack_require__("0xBU"),"alt":"好分数辅导微信公众号"}}),_vm._v(" "),_c('span',{staticClass:"qr-codes__text"},[_vm._v("好分数辅导微信公众号")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-info"},[_c('span',{staticClass:"company-info__item"},[_vm._v("北京市海淀区东升科技园学院八号")]),_vm._v(" "),_c('i',{staticClass:"company-info__separator"}),_vm._v(" "),_c('span',{staticClass:"company-info__item"},[_vm._v("2014-2021 北京修齐治平科技有限公司")]),_vm._v(" "),_c('i',{staticClass:"company-info__separator"}),_vm._v(" "),_c('span',{staticClass:"company-info__item"},[_c('a',{attrs:{"target":"_blank","href":"https://beian.miit.gov.cn/"}},[_vm._v("\n                        京ICP备16000182号-5\n                    ")])]),_vm._v(" "),_c('i',{staticClass:"company-info__separator"}),_vm._v(" "),_c('span',{staticClass:"company-info__item"},[_c('a',{attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042360"}},[_c('img',{staticClass:"footer-gaba",attrs:{"src":__webpack_require__("1tYL")}}),_vm._v("京公网安备11010502042360号\n                    ")])])])}]


/***/ }),

/***/ "tqoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_teacher_avatar_png__ = __webpack_require__("I99j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_teacher_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_teacher_avatar_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            'type': String,
            'default': ''
        },
        size: {
            'type': Number,
            'default': 64
        },
        url: String,
        defaultUrl: {
            'type': String,
            'default': ''
        },
        type: {
            // circle or rect
            'type': String,
            'default': 'circle'
        },
        bg: {
            'type': String,
            'default': '#DBDCE0'
        },
        color: {
            'type': String,
            'default': '#FAFAFA'
        }
    },
    data: function data() {
        return {
            src: '',
            avatar: __WEBPACK_IMPORTED_MODULE_0__static_teacher_avatar_png___default.a
        };
    },

    computed: {
        styles: function styles() {
            var fs = Math.ceil(this.size / 2.5);
            return 'font-family: Hiragino_Sans_GB_W3; font-size: ' + fs + 'px';
        },
        showUrl: function showUrl() {
            if (this.name !== '') {
                return '';
            }
            return this.url || this.defaultUrl || this.avatar;
        },
        showName: function showName() {
            return this.name ? this.name.slice(0, 1) : '-';
        }
    },
    mounted: function mounted() {
        this.src = this.showUrl;
    },

    watch: {
        url: function url() {
            this.src = this.showUrl;
        }
    },
    methods: {
        handleError: function handleError() {
            this.$refs.avatarImg.setAttribute('src', this.avatar);
        }
    }
});

/***/ }),

/***/ "vng7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4JpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo4NWFiMjEwMi1lYjg0LTRkY2UtYmY0Ny05MGMxZThjNmU3MTgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTE4OEVGMUIyRUE3MTFFNUI0RDVBRDMxNTMyM0I5MDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTE4OEVGMUEyRUE3MTFFNUI0RDVBRDMxNTMyM0I5MDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjkwMDgyOGM4LTk2ODEtNDcwMi04Yjc5LWM2NWI4Y2Q1MDgwYiIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmQxNzgzYmYzLTc0YTUtMTE3OC1hZDZiLTkwYWU2NjVmZjY3ZiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pvw5LV8AAACOSURBVHjafJDBDUBQDIZLrMDRAqbgzBKIC9uIG6swhSU4mYC/0ibVgybfS/R9eX81uLoqJaIRtOCkb8VgAUOEYwIl2EBu5Fh6GX+EoAG7NDYRrMR3Db94gAKsRiYjvSmRNL1MVtJorZt+SsXEzeRnfsXERGpc4eVQ9pS5mQ4nL/wzvcTXbuEqz7zwR4ABALK3KH5fA95eAAAAAElFTkSuQmCC"

/***/ }),

/***/ "vvAD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ErrorCode: {
        Success: 0,
        Empty: 1,
        CookieInvalid: 1101
    },
    Subject: {
        1: '语文',
        2: '数学',
        3: '英语',
        4: '物理',
        5: '化学',
        6: '生物',
        7: '政治',
        8: '历史',
        9: '地理',
        10: '奥数'
    },
    WeekDay: {
        0: '星期日',
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六'
    },
    Grade: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        11: '小学一年级',
        12: '小学二年级',
        13: '小学三年级',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下',
        1: '小学',
        2: '初中',
        3: '高中'
    },
    Grade2: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    Grade3: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        36: '高二',
        37: '高三',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    TransactionStatus: {
        1: '处理中',
        2: '支付成功',
        3: '支付失败',
        4: '交易关闭',
        5: '取消充值'
    },
    GoodsType: {
        1: '学费',
        2: '学豆'
    },
    PayThrough: {
        1: '学费余额',
        11: '支付宝',
        12: '支付宝',
        13: '支付宝',
        14: '花呗分期',
        97: '支付宝',
        21: '微信',
        22: '微信',
        23: '微信',
        24: '微信',
        25: '微信',
        26: '微信',
        27: '微信',
        31: '财付通',
        41: '慧学空间',
        51: '课时置换',
        52: '课时变更',
        61: '民生银行',
        71: '度小满金融',
        95: '银联',
        96: '银联',
        98: '旧平台',
        99: '未知'
    },
    LessonType: {
        // 试听
        FREE_LESSON: 1,
        // 课时计划
        FORMAL_LESSON: 2,
        // 答疑课
        QA_LESSON: 3
    },
    // 标准课时包等级
    StandardClassPackageLevel: {
        1: '基础',
        2: '高级',
        3: 'VIP'
    },
    // 课时记录类型
    PeriodRecordType: {
        1: '一般课时包',
        2: '标准课时包',
        3: '标准课时包升级',
        4: '订单'
    }
};

/***/ }),

/***/ "yeTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBackTop_vue__ = __webpack_require__("ghFu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0245acc0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBackTop_vue__ = __webpack_require__("FAiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ZJhb")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0245acc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppBackTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0245acc0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBackTop_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0245acc0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppBackTop_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zhMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_enum__ = __webpack_require__("vvAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__constants_enum__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        simple: {
            type: Boolean,
            default: true
        },
        isShowPromise: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            PriceDialog: false,
            priceContent: [],
            Grade3: __WEBPACK_IMPORTED_MODULE_0__constants_enum__["Grade3"]
        };
    },

    methods: {
        handlePriceDialog: function handlePriceDialog() {
            var _this = this;

            this.$http.get('/v1/config/pricing').then(function (resp) {
                return _this.$checkResp(resp, []);
            }).then(function (data) {
                data.forEach(function (item) {
                    item.gradeStr = __WEBPACK_IMPORTED_MODULE_0__constants_enum__["Grade3"][item.grade];
                    item.basicPrice = +(item.originalPrice[0] / 100).toFixed(2);
                    item.seniorPrice = +(item.originalPrice[1] / 100).toFixed(2);
                    item.vipPrice = +(item.originalPrice[2] / 100).toFixed(2);
                });
                _this.priceContent = data;
                _this.PriceDialog = true;
            });
        }
    }
});

/***/ })

},["Rra/"]);


// WEBPACK FOOTER //
// static/js/index.7c1b11316fb85622a80a.js